import React, { ChangeEvent, FunctionComponent, useEffect, useState } from 'react';
import { HTMLInputElement } from 'window-or-global';
import styles from './switch-component.module.scss';

type SwitchProps = {
  id: string;
  className?: string;
  label?: string;
  checkedValue?: boolean;
  disabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

/**
 * Switch component
 *
 * https://www.figma.com/file/jiN4FkdkhDZIWxIkPS6Ru7/design-system?node-id=38%3A6
 */
export const Switch: FunctionComponent<SwitchProps> = ({ id, className = '', label, checkedValue = false, disabled, onChange }) => {
  const [isChecked, setIsChecked] = useState(checkedValue);

  useEffect(() => {
    setIsChecked(checkedValue);
  }, [checkedValue]);

  const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(!isChecked);
    onChange && onChange(event);
  };

  return (
    <div className={`${styles['switch-component']} ${className}`} data-testid={id}>
      <input
        type='checkbox'
        id={id}
        checked={isChecked}
        onChange={changeHandler}
        disabled={disabled}
        aria-label={label ? label : 'switch'}
      />
      <label htmlFor={id}>
        {label && <span className={styles['label-text']}>{label}</span>}
        <div className={`${styles.slider} ${className}`}></div>
      </label>
    </div>
  );
};

export default Switch;
